import request from "@/utils/request";

function getVerificationCode(data) {
  return request({
    url: '/Api/login/getVerificationCode',
    method: 'post',
    data
  })
}

function loginByPhone(data) {
  return request({
    url: '/Api/login/loginByPhone',
    method: 'post',
    data
  })
}

function selectAccount(data) {
  return request({
    url: '/Api/login/selectAccount',
    method: 'post',
    data: data
  })
}

export {
  getVerificationCode,
  loginByPhone,
  selectAccount
}
